import { Card } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Root = styled(Card)`
  max-width: 100%;
  width: ${({ fullScreen }) => (fullScreen ? undefined : '450px')};
`;
